import React from 'react';
import { useQuery } from '@apollo/client';
import Initialization from '@/components/pages/user/Initialization';
import EntityErrorState from '@/se/components/entity-states/EntityErrorState';
import { scope } from '../graph/scope';

export const Scope = React.createContext<any>(null);

export const withScope = (Component: any) => {
  const WithScope = (props: any) => <Scope.Consumer>{scope => <Component {...props} scope={scope} />}</Scope.Consumer>;

  WithScope.displayName = `withScope(${Component.displayName || Component.name || 'Component'})`;
  return WithScope;
};

export const ScopeProvider = ({ children }) => {
  const { data, loading, error } = useQuery(scope);

  if (loading) {
    return <Initialization />;
  }

  if (error) {
    return <EntityErrorState error={error} />;
  }

  if (!data?.scope) {
    return <EntityErrorState error={new Error('Scope data unavailable.')} />;
  }

  return <Scope.Provider value={data.scope}>{children}</Scope.Provider>;
};
